import { AppColors } from "@/assets/colors";
import { pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Header from "@/components/home/header";

export default function ErrorPage() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      <Image
        src="/images/error/404 error.svg"
        alt="404 error image"
        width={495}
        height={385}
        style={{ objectFit: "contain" }}
      />
      <Typography className={classes.headTxt}>Page not found</Typography>
      <Header
        name={"Whoops! That page doesn't exist."}
        isAction={false}
        description={
          "The page you're looking for cannot be found. Don't worry though, our team of digital explorers is on the case, tirelessly searching for the missing content. In the meantime, why not take a moment to explore our website."
        }
      />
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  headTxt: {
    color: AppColors.primary["300"],
    fontFamily: "General sans",
    fontWeight: 600,
    fontSize: pxToRem(20),
    marginBottom: theme.spacing(-4)
  },
}));
